import uniq from 'lodash/uniq';

import Question from '@evidentid/ido-lib/interfaces/Question';

import { AttributesValues } from '@/store/interfaces/RawIdoActions';
import findQuestionsForAttributeTypes from '@/utils/findQuestionsForAttributeTypes';

export default function extractAttributeTypesFromValues(
    attributesValues: AttributesValues,
    questions: Question[],
): string[] {
    // Get list of attribute types
    const baseAttributeTypes = Object.keys(attributesValues);

    // Combine it with questions
    const attributeTypes = [
        ...findQuestionsForAttributeTypes(questions, baseAttributeTypes).map((question) => question.attrType),
        ...baseAttributeTypes,
    ];

    return uniq(attributeTypes);
}
